import { apiHelper } from "./api_helper";

export const KHOANNOP_GROUP_API_ENDPOINT = 'sf-khoannop-group';
export const khoanNopGroupApi = {
    SelectAll: () => apiHelper.get(`${KHOANNOP_GROUP_API_ENDPOINT}`),
    SelectIsDichVu: (dm_coso_id) => apiHelper.get(`co-so/${dm_coso_id}/sf-khoannop-group`),
    SelectByHocSinh: (data) => apiHelper.post(`sf-khoannop-group/select-by-hs`,data),
    GetKhoanNop: (truong_id, khoi_id, he_id, nam_hoc, co_so, hoc_sinh) => apiHelper.get(`sf-khoannop-group/get-khoan-nop?truong_id=${truong_id}&khoi_id=${khoi_id}&he_id=${he_id}&nam_hoc=${nam_hoc}&coso=${co_so}&hoc_sinh=${hoc_sinh}`),
    InsertKhoanThu: (formData) => apiHelper.post(`sf-khoannop-group/insert-khoan-thu`, formData),
    CheckPaymentStatus: (formData) => apiHelper.post(`sf-khoannop-group/check-payment-status`, formData)
}